import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import set from 'lodash/fp/set'
import update from 'lodash/fp/update'

import {
    fetchBrandGroupsSuccess,
    createBrandGroupSuccess,
    updateBrandGroupSuccess,
    deleteBrandGroupSuccess,
} from 'actions/ui/app'
import { BrandGroup } from 'types'

import type { AppState } from './state'

export const addBrandGroupsCases = (
    builder: ActionReducerMapBuilder<AppState>
): void => {
    builder
        .addCase(fetchBrandGroupsSuccess, (state, action) =>
            set(['brandGroups'], action.payload.results, state)
        )
        .addCase(createBrandGroupSuccess, (state, action) =>
            update(['brandGroups'], (brandGroups: BrandGroup[]) =>
                brandGroups.concat(action.payload)
            )(state)
        )
        .addCase(updateBrandGroupSuccess, (state, action) =>
            update(['brandGroups'], (brandGroups: BrandGroup[]) =>
                brandGroups.map((brandGroup) =>
                    brandGroup.id === action.payload.id
                        ? action.payload
                        : brandGroup
                )
            )(state)
        )
        .addCase(deleteBrandGroupSuccess, (state, action) =>
            update(['brandGroups'], (brandGroups: BrandGroup[]) =>
                brandGroups.filter(
                    (brandGroup) => brandGroup.id !== action.payload
                )
            )(state)
        )
}
